export const ContentTypeFormStyles = {
  form: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    marginTop: 2,
  },
  fieldRow: {
    display: "flex",
    gap: 2,
    alignItems: "center",
  },
};

export default ContentTypeFormStyles;
